import React, { Component } from 'react';
import {
    toast, ToastContainer, MDBCardText, MDBCard, MDBCardTitle, MDBRow, MDBCol, MDBBtn,
    MDBIcon, MDBInput, MDBInputGroup, MDBContainer, MDBBadge, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter
} from 'mdbreact';
import Header from './ComponentFragments/Header';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Colors from '../Styles/Colors';

import CanvasJSReact from '../Assets/canvasjs.react';
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

class CriteriaPrizes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            levelAchieved: props.location.state.criteriaData[0].isSalesBased ? props.location.state.criteriaData[0].salesProgress : props.location.state.criteriaData[0].otherProgress,
            criteriaData: props.location.state.criteriaData,
            rewardsData: props.location.state.criteriaData[0].rewardList,
            resultAreaId: props.location.state.resultAreaId
        }
        this.formatter = new Formatter();
        this.dl = new DataLayer();
        this.showPrizes = this.showPrizes.bind(this);
        this.showButton = this.showButton.bind(this);
    }


    async componentWillMount() {
        this.props.loaderOff();

    }

    showPrizes = (criteriaItem) => {
        this.setState({
            rewardsData: criteriaItem.rewardList
        });

    }

    showButton(resultAreaId, criteria) {
        if (this.state.criteriaData.length > 1) {
            if (resultAreaId != 14) {
                return (
                    <div className="flex-row text-right" >
                        <MDBBtn rounded color="purple" size="sm" onClick={() => this.showPrizes(criteria)}>View Prizes</MDBBtn>
                        

                    </div>
                )
            }
        } else {
            return (<div></div>)
        }

        
    }

    render() {
        return (
            <div>
                <Header headerText="Criteria And Prizes"
                    hideSearch={true}
                    subHeaderText={this.props.location.state.subHeader}
                    subHeaderTextSize="20px"
                />
                <MDBRow>

                    <MDBCol xl="4" lg="4" md="6" sm="12" className="mb-r" >
                        <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                            {
                                this.state.criteriaData.map((criteria) => {
                                    let data1 = criteria.amount1
                                    let data2 = criteria.isSalesBased ? criteria.salesProgress : criteria.otherProgress;

                                    const options = {
                                        title: {
                                            text: "Levels"
                                        },
                                        height: 200,
                                        backgroundColor: "#d5deeb",
                                        data: [
                                            {
                                                // Change type to "doughnut", "line", "splineArea", etc.
                                                type: "column",
                                                dataPoints: [
                                                    { label: "Qualifying Level Required", y: criteria.amount1 },
                                                    { label: "Level Achieved", y: criteria.isSalesBased ? criteria.salesProgress : criteria.otherProgress }

                                                ]
                                            }
                                        ]
                                    }
                                    return (
                                        <MDBCardText>
                                            <div>Qualify With:&nbsp;{criteria.resultDescription}</div>
                                            <div>Min Qualify Value:&nbsp;{criteria.isSalesBased ? this.formatter.formatCurrency(criteria.amount1) : criteria.amount1}</div>
                                            <div>Progress:&nbsp;{criteria.isSalesBased ? this.formatter.formatCurrency(criteria.salesProgress) : criteria.otherProgress}</div>
                                            <div>Achieved:&nbsp;{criteria.passed ? "True" : "False"}</div>
                                            <div style={{ marginTop: "5px" }}>
                                                <CanvasJSChart options={options}
                                                /* onRef={ref => this.chart = ref} */
                                                />
                                                {/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
                                            </div>
                                            {this.showButton(this.state.resultAreaId, criteria)}

                                            <hr />

                                        </MDBCardText>

                                    )
                                })
                            }
                        </MDBCard>
                    </MDBCol>


                    <MDBCol xl="8" lg="8" md="6" sm="12" className="mb-r" >
                        <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                            {
                                this.state.rewardsData.map((reward) => {
                                    return (
                                        <div>
                                            <MDBRow>
                                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r">
                                                    <MDBCardText>

                                                        <div>Qualify With:&nbsp;{this.formatter.formatCurrency(reward.qualifyingValue / 100)}</div>
                                                        {reward.forEveryAmount > 0 ? (<div>For every {reward.forEveryAmount}&nbsp;achieved earn 1 of this reward</div>) : (<div></div>)}
                                                        <div>Reward:&nbsp;{reward.invoiceDescription}</div>
                                                        <div>{reward.cummulative ? "This reward is cummulative" : "This reward is not cummulative"}</div>


                                                    </MDBCardText>
                                                </MDBCol>
                                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r">
                                                    <MDBCardText>
                                                        {reward.achieved ?
                                                            (
                                                                <div>
                                                                    <span style={{ fontSize: "20px" }}><MDBIcon far icon="check-circle" style={{ color: "green" }} /></span>&nbsp;Congratulations you have achieved this reward
                                                                </div>
                                                            ) :
                                                            (
                                                                <div>
                                                                    {(reward.qualifyingValue / 100) < this.state.levelAchieved ? (<div></div>) : (<div><span style={{ fontSize: "20px" }}><MDBIcon far icon="times-circle" style={{ color: "red" }} /></span>&nbsp;Only {this.formatter.formatCurrency((reward.qualifyingValue / 100) - this.state.levelAchieved)} to go to achieve this reward</div>)}

                                                                </div>
                                                            )}




                                                    </MDBCardText>
                                                </MDBCol>

                                            </MDBRow>
                                            <hr />
                                        </div>
                                    )
                                })
                            }
                        </MDBCard>
                    </MDBCol>
                </MDBRow>

            </div>
        )
    }
}

export default CriteriaPrizes;



